// @core/api/endpoints/team/list_teams.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List teams with full details
 * Returns a paginated list of teams with all fields.
 */
export async function ListTeams(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/full`;
  const requestOptions = options;
  return client.get<ListTeamsResponse>(requestPath, { ...requestOptions, params });
}
